import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'THIS FIELD IS REQUIRED.' }
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'THIS FIELD IS REQUIRED.' }
      ]
    },
    Email: {
      validations: [
        { type: 'required', message: 'THIS FIELD IS REQUIRED.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    SiteName: {
      validations: []
    },
    PlannedGuestCount: {
      validations: []
    },
    Category: {
      validations: []
    },
    Notes: {
      validations: [
        { type: 'required', message: 'THIS FIELD IS REQUIRED.' }
      ]
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'FIRST NAME *',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Required for initial submission.',
            mapping: 'headerLabel',
            customClasses: ['subheader']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'FIRST NAME *',
            mapping: 'FirstName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'LAST NAME *',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Required for initial submission.',
            mapping: 'headerLabel',
            customClasses: ['subheader']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'LAST NAME *',
            mapping: 'LastName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'EMAIL *',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Required for initial submission. Will not be published.',
            mapping: 'headerLabel',
            customClasses: ['subheader']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'EMAIL *',
            mapping: 'Email',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'PHONE NUMBER',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },     
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Optional, but we generally like to call you to find out more!',
            mapping: 'headerLabel',
            customClasses: ['subheader']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'PHONE NUMBER',
            mapping: 'TelNumber',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'EVENT DATE',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },   
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Required for initial submission.',
            mapping: 'headerLabel',
            customClasses: ['subheader']
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'EVENT DATE *',
            mapping: 'EventDate',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'VENUE NAME',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },   
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Required for initial submission.',
            mapping: 'headerLabel',
            customClasses: ['subheader']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'VENUE NAME',
            mapping: 'SiteName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'NUMBER OF GUESTS',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },   
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Required for initial submission.',
            mapping: 'headerLabel',
            customClasses: ['subheader']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'NUMBER OF GUESTS',
            mapping: 'PlannedGuestCount',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'EVENT TYPE',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },   
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Required for initial submission.',
            mapping: 'headerLabel',
            customClasses: ['subheader']
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'EVENT TYPE',
            options: [
              { label: 'Wedding Reception', value: 'Wedding Reception' },
              { label: 'Dinner Party', value: 'Dinner Party' },
              { label: 'Holiday Dinner', value: 'Holiday Dinner' },
              { label: 'Holiday Party', value: 'Holiday Party' },
              { label: 'Memorial Service', value: 'Memorial Service' },
              { label: 'Corporate Event', value: 'Corporate Event' }
            ],
            mapping: 'Category',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'MESSAGE *',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },   
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Required for initial submission.',
            mapping: 'headerLabel',
            customClasses: ['subheader']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'MESSAGE *',
            mapping: 'Notes',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND YOUR MESSAGE'
          }
        ]
      }
    ]
  },
  info: {
    title: 'The Hidden Table Contact Form',
    formId: '426',
    clientKey: '623BFE16-3C41-4A01-B857-1D9CEF50BF31',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
